import type { FC } from 'react';

import { useBulkSelectionContext } from '../BulkSelectionContext';
import Checkbox from '../Checkbox';

interface BulkSelectionSingleCheckboxProps {
  itemId: string;
  selectionId: string;
}

const BulkSelectionSingleCheckbox: FC<BulkSelectionSingleCheckboxProps> = ({ itemId, selectionId }) => {
  const { addItems, getItems, removeItems } = useBulkSelectionContext();

  const selectedItems: string[] = getItems(selectionId);
  const isChecked: boolean = !!selectedItems.find((item: string) => item === itemId);

  const handleChange = (): void => {
    if (isChecked) {
      return removeItems(selectionId, [itemId]);
    }

    addItems(selectionId, [itemId]);
  };

  return <Checkbox key={itemId} checked={isChecked} className="m-auto" onChange={handleChange} />;
};

export default BulkSelectionSingleCheckbox;
